<template>
    <div class="root-child">
        <img style="width:100%" :src="bannerImage" alt=""/>
        <div class="title-class">{{data.roomType}}</div>
        <div v-if="data.minCheckIn === data.maxCheckIn" class="p-class">仅可入住{{data.minCheckIn}}</div>
        <div v-else class="p-class">最少入住{{data.minCheckIn}}人，可入住{{data.minCheckIn}}-{{data.maxCheckIn}}人</div>
        <div>
            <span class="tab-class">{{data.floor || '未知楼'}}层</span>
            <span class="tab-class">{{data.area || '未知'}}m²</span>
            <span v-if="data.hasBalcony === '1'" class="tab-class">有阳台<span v-if="data.balconyArea">{{data.balconyArea}}m²</span></span>
            <span v-else class="tab-class">没有阳台</span>
        </div>
        <div class="p-class">
            <div v-if="data.roomFacilities">
              <p>【房间配有】{{data.roomFacilities}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import jlkjCenterImg from "./components/jlkj-center-img.vue"
import { Notify } from 'vant';
export default {
    components:{
        jlkjCenterImg
    },
    data(){
        return{
          id: this.$route.query.id || '',
          loading: true,
          data: {},
        }
    },
    computed: {
      bannerImage: function() {
        if (this.data.picturePaths) {
          const target = this.data.picturePaths.find(item => item.isCover === '1');
          if (target) {
            return target.filePath;
          } else {
            return this.data.picturePaths[0].filePath;
          }
        } else {
          return '';
        }
      }
    },
    created(){
      if (this.$route.query.id) {
        this.fetchData();
      }
    },
    methods:{
      fetchData() {
        this.loading = true;
        this.$API.cruise
          .getCruiseRoomTypesDetail(this.id)
          .then(res => {
            if (res.code < 300) {
              this.data = res.data;
            } else {
              Notify(res.msg);
            }
          })
          .catch(err => {
            console.log(err.message);
            Notify(err.msg || '查询数据失败');
          })
          .finally(() => {
            this.loading = false;
          })
      },
    }
}
</script>
<style scoped>
    @import "../../lib/flex-list.css";
    .root-child > div{
        width:100vw;
        padding:10px 15px 0 15px;
        box-sizing: border-box;
    }
    .root-child > div:first-child{
        padding:0;
    }
    .top-img-class{
        width:100vw;
        height: calc( 100vw / 5 * 3 );
        overflow:hidden;
    }
    .img-width-100{
        width:100vw;
    }
    .img-height-100{
        height:100vh;
    }
    .title-class{
        font-size: 16px;
        font-weight: bold;
        color: #333333;
    }
    .tab-class{
        font-size: 11px;
        color: #3377FF;
        border-radius: 2px;
        border: 1px solid #3377FF;
        margin-right:5px;
        padding: 2px 5px;
    }
    .p-class{
        font-size: 13px;
        color: #666666;
        line-height: 2em;
    }
</style>
